import { render, staticRenderFns } from "./MordaLentaButtonFund.vue?vue&type=template&id=0dedc7f1&scoped=true"
import script from "./MordaLentaButtonFund.vue?vue&type=script&lang=js"
export * from "./MordaLentaButtonFund.vue?vue&type=script&lang=js"
import style0 from "./MordaLentaButtonFund.vue?vue&type=style&index=0&id=0dedc7f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedc7f1",
  null
  
)

export default component.exports